import React, { useState, FC } from 'react'

import { EditForm } from 'modules/weeks/Create/containers/Form/EditForm'
import { CreateToolbar, AsidePreview } from 'modules/weeks/Create/containers'
import { EditProps, Edit, SimpleForm } from 'react-admin'
import { FormProvider } from 'contexts'

export const EditWeeks: FC<EditProps> = (props: any) => {
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const [formData, setFormData] = useState([])

  return (
    <>
      <Edit {...props}>
        <SimpleForm>
          <FormProvider>
            <EditForm
                {...props}
                setFormData={setFormData}
                toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
                aside={showAside ? <AsidePreview formData={formData} /> : <></>}
                onSubmitSuccess={onSubmitSuccess}
                onSubmitFailure={onSubmitFailure}
                shouldRedirect={shouldRedirect}
                resource="cms/grouper/week"
              />
          </FormProvider>
        </SimpleForm>
      </Edit>
    </>
  )
}
